module.exports = __webpack_public_path__ + "static/media/coming_soon.a1805f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/coming_soon.png
// module id = 497
// module chunks = 0